import {AutoComplete, Select} from 'antd';
import React from "react";
import IFieldOptions from "../../../../../../model/interface/form/elementOptions/IFieldOptions";
import _, {debounce} from "underscore";
import IRestServiceOptions from "../../../../../../model/interface/api/IRestServiceOptions";
import {connect} from "react-redux";
import selectors from "../../../../../../redux/selectors";
import IRepositoryService from "../../../../../../model/interface/IRepositoryService";
import IFormElementProps from "../../../../../../model/interface/form/IFormElementProps";
import IRestServiceOrders from "../../../../../../model/interface/api/IRestServiceOrders";
import IField from "../../../../../../model/interface/dataStorage/IField";
import store, {IAppState} from "../../../../../../redux/store";
import DataStorageHelper from "../../../../../../utils/DataStorageHelper";


interface IProps extends IFormElementProps {
    value?: string | (string)[],
    onChange?: (key?: number | string | (string | number)[], label?: string | JSX.Element | (string | JSX.Element)[]) => void
    options: IFieldOptions
    findServiceByClassName: (name: string) => IRepositoryService
    field: IField
    getText: (code: string, fallBack?: string, params?: {}) => string
}

interface IState {
    value?: string | (string)[],
    data: { [x: string]: string | JSX.Element },
    loading: boolean
    options: IFieldOptions
}

const SELECT_ALL = '_all'

class FormFieldTextSelect extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            data: {},
            loading: false,
            options: props.options
        };
        this.fetch = debounce(this.fetch, 800);
    }

    isUnmounted = false;
    inputRef: any

    componentDidMount() {

        try {
            this.fetchData().then(() => this.selectActive()).then()
        } catch (e) {
            console.error(e)
        }
    }

    autoFocus() {
        const {autoFocus} = this.props.options
        autoFocus && setTimeout(() => this.inputRef?.focus?.(), 100)
    }

    componentWillUnmount() {
        this.isUnmounted = true;
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        const {dependentFields} = this.props.options
        dependentFields?.forEach(field => {
            if (this.props.resource?.[field] !== prevProps.resource?.[field]) {
                this.fetch()
            }
        })
        if (this.props.value !== prevProps.value) {
            this.selectActive()
        }
        this.autoFocus()
    }

    getService() {
        const {options, findServiceByClassName} = this.props

        if (this.props.field && this.props.field.targetEntity) {
            return findServiceByClassName(this.props.field.targetEntity)
        }

        // @deprecated
        return options.textSelectFullClassName ? findServiceByClassName(options.textSelectFullClassName) : undefined;
    }


    selectActive() {
        if (this.props.value && !this.isUnmounted) {
            return this.setState({
                value: this.props.value,
                loading: false
            });
        }
    }

    fetch = (value?: string) => {
        const {options} = this.props
        if (options.dependentFields?.length && !value) {
            this.fetchData().then(() => this.selectActive()).then()
        }
    }

    buildOrderCriteria() {
        let orderBy = {} as IRestServiceOrders
        const {options} = this.props
        if (typeof options.textSelectOrderField === "string") {
            const field = _.findWhere(this.getService()?.getFields() || [], {uuid: options.textSelectOrderField})
            if (field) {
                orderBy[field.name] = {
                    field: field.name,
                    direction: options.textSelectOrderDirection as 'ASC' | "DESC" || 'ASC'
                }
            }
        }
        if (Array.isArray(options.textSelectOrderField)) {
            options.textSelectOrderField.forEach(fieldName => {
                orderBy[fieldName] = {
                    field: fieldName,
                    direction: options.textSelectOrderDirection as 'ASC' | "DESC" || 'ASC'
                }
            })
        }
        return orderBy
    }

    fetchData(params?: IRestServiceOptions) {
        const service = this.getService()
        const {options, resource, functions} = this.props
        const {textSelectPresenter, textSelectFilters} = options
        if (!service || !service.choiceList) {
            console.error('Service is not defined', params)
            return new Promise(() => ([]))
            // throw new Error('Service is not defined')
        }
        const filters = {...params?.filters, ...textSelectFilters}
        const route = selectors.routes.extractRouteParametersFromUrl(store.getState(), window.location.pathname)
        this.setState({data: {}, loading: true})
        return service.choiceList(textSelectPresenter || service.getDefaultPresenter().name, {
            ...params,
            filters: filters,
            order: this.buildOrderCriteria(),
            route,
            resource: resource ? {
                object: DataStorageHelper.shortenLongStringProperties(DataStorageHelper.buildFormData(resource, functions.getContentType(), undefined, undefined, true)),
                className: functions.getContentType().fullClassName
            } : undefined
        }).then(({results}) => {
            this.setState({
                data: results,
                loading: false
            })
        })
    }

    formatData() {
        let {data} = this.state
        if (!data || typeof data !== 'object') {
            return []
        }
        let choices = Object.keys(data).map(id => ({
            key: id,
            label: data[id].toString(),
            value: data[id].toString(),
        }))
        if (this.props.options.processData) {
            choices = this.props.options.processData(choices)
        }

        //TODO label might be null , fix here or in backend ???
        if (!this.props.options.textSelectOrderField) {
            choices.sort((a: any, b: any) => {
                return (typeof a.label === 'object' ? a.label?.props?.children + "" : a.label + "")
                    .localeCompare(typeof b.label === 'object' ? b.label?.props?.children + "" : b.label + "")
            })
        }

        return choices
    }

    handleChange = (option: any) => {
        const {multiple} = this.props.options
        let value: any
        if (multiple) {
            if (!Array.isArray(option)) {
                option = [option]
            }
            value = option ? option.map((oneOption: any) => typeof oneOption === "object" ? oneOption.value : oneOption) : []
            if (value.find((v: string | number) => v === SELECT_ALL)) {
                value = this.formatData().map(d => d.key)
            }
        } else {
            value = (typeof option === "object" && option) ? option.value : option
        }
        this.setState(() => ({
            value,
            loading: false,
        }), this.updateParent)
    };

    updateParent = () => {
        const {value, data} = this.state
        this.props.onChange?.(value, Array.isArray(value) ? value.map(v => data[v]) : (value ? data[value] : ''))
    }

    render() {
        const {loading, value} = this.state
        const {
            style,
            placeholder,
            showClear,
            disabled,
            multiple,
            textSelectDropdownMatchSelectWidth,
            textSelectDropdownHeight
        } = this.props.options
        const props = {style, placeholder, allowClear: showClear}
        const data = this.formatData()

        try {
            return <>
                {multiple ? <Select dropdownMatchSelectWidth={textSelectDropdownMatchSelectWidth} loading={loading}
                                    onChange={this.handleChange}
                                    mode={'tags'} options={data} listHeight={textSelectDropdownHeight}
                                    value={value}/> :
                    <AutoComplete
                        options={data} disabled={disabled} listHeight={textSelectDropdownHeight}
                        onChange={this.handleChange} value={value as string}
                        {...props} dropdownMatchSelectWidth={textSelectDropdownMatchSelectWidth}
                        filterOption={(inputValue, option) =>
                            option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                        }
                    />}
            </>
        } catch (e) {
            return <>Render failed: {JSON.stringify(e)}</>
        }
    }
}

const mapStateToProps = (store: IAppState) => {
    return {
        findServiceByClassName: (name: string) => selectors.services.findOneByFullClassName(store, name),
        getText: (code: string, fallback?: string, params?: {}) => selectors.dictionary.getMessage(store, code, fallback, params)
    }
}
export default connect(mapStateToProps)(FormFieldTextSelect)